export const formatTime = (mins) => {
  const hours = mins / 60 | 0;
  const minutes = mins - (hours * 60);
  return `0${hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
}
export const getTimeString = (date) => {
  const str = new Date(date).toLocaleTimeString();
  return str.substr(0, str.length - 3);
}
export const getStatus = (value) => value === 0 ? 'Inactive' : value === 1 ? 'Active' : 'Expired';